import { createI18n } from "vue-i18n";
import zhTW from "./translations/zh-TW.json";
import en from "./translations/en.json";
import ja from "./translations/ja.json";
import ko from "./translations/ko.json";

// i18n-js v4 generates JSON with locale as top-level key
const messages = {
  "zh-TW": zhTW["zh-TW"] || zhTW,
  en: en["en"] || en,
  ja: ja["ja"] || ja,
  ko: ko["ko"] || ko,
};

const i18n = createI18n({
  legacy: false, // use Composition API
  locale: window.currentLocale || "en",
  fallbackLocale: "en",
  messages,
});

export default i18n;
